export default "__VITE_ASSET__baAaetsYazQo0z9pNTe1iQ__"